module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (9).f3e5e0fc.svg";